import React, { useState } from 'react';
import { isAxiosError } from 'axios';
import { FormComponent, UiComponent } from 'components';
import { AdminsQuery } from 'queries';
import { IAdmin } from 'types';
import useModal from 'hooks/useModal';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';

interface Props {
  admin: IAdmin;
}

// 계정 비밀번호를 입력한 값으로 재설정
function PasswordReset({ admin }: Props) {
  const { handleClose, handleAlert } = useModal();
  const { mutateAsync: update, isPending } = AdminsQuery.useUpdate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');

  const handleSubmit = async () => {
    if (password.length < 8) {
      handleAlert('비밀번호는 8자 이상 입력해주세요');
      return;
    }
    if (password !== confirm) {
      handleAlert('비밀번호가 일치하지 않습니다');
      return;
    }
    try {
      await update({ id: admin.id, password });
      toast.success('비밀번호가 재설정되었습니다');
      handleClose();
    } catch (error) {
      const message = isAxiosError<{ message?: unknown }>(error)
        ? error.response?.data?.message
        : undefined;
      toast.error(
        typeof message === 'string' ? message : DEFAULT_ERROR_MESSAGE,
      );
    }
  };

  return (
    <div css={{ width: 360, '> p': { margin: '16px 0 8px', fontWeight: 600 } }}>
      <p>새 비밀번호</p>
      <FormComponent.Input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="8자 이상"
        css={{ width: '100%' }}
      />
      <p>새 비밀번호 확인</p>
      <FormComponent.Input
        type="password"
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
        css={{ width: '100%' }}
      />
      <div css={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
        <UiComponent.Button
          type="button"
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={isPending}
        >
          재설정하기
        </UiComponent.Button>
      </div>
    </div>
  );
}

export default PasswordReset;
